<template>
    <div class="bg-light d-flex flex-column flex-1 overflow-hidden">
        <header class="bg-white d-flex flex-row justify-content-between align-items-center">
            <div class="d-flex flex-row align-items-center p-2">
                <a class="me-2 fs-3 text-dark cp btn-rounded btn-default btn" @click="$router.back();"><i class="mdi mdi-arrow-left"></i></a>
                <img :src="data.image" class="me-3" style="border-radius: 50%; width: 2.5em; height: 2.5em" v-if="data.image">
                <h5 class="m-0">{{data.name}}</h5>
            </div>
            <div class="d-flex flex-row px-3">
                <select v-if="Object.keys(data).length > 1 && !data_loading  && data_type " class="form-select fw-600 text-muted me-2 w-auto" v-model="filter.q">
                  <option :value="q" v-for="q in 4" :key="q">Quarter {{q}}</option>
              </select>
              <select v-if="Object.keys(data).length > 1 && !data_loading && !data_type " class="form-select fw-600 text-muted me-2 w-auto" v-model="filter.m">
                  <option :value="month" v-for="month in 12" :key="month">{{format('2020-'+month+'-1')}} </option>
              </select>
              <select v-if="Object.keys(data).length > 1 && !data_loading" class="form-select fw-600 text-muted" v-model="filter.y">
                  <option :value="year(i)" v-for="i in 3" :key="i">{{year(i)}}</option>
              </select>
            </div>
        </header>
        <div class="performance px-2" :class="{'show':show_contract}" ref="performance">     
            <div class="d-flex flex-column position-relative bg-white w-100 h-100" v-if="Object.keys(data).length > 1 && !data_loading">
                <div class="position-absolute w-100 h-100 overflow-auto">
                    <div class="container bg-light py-3">
                        <div class="card" style="border-radius: 5px; min-height: 600px;" v-if="typeof data.contract !== 'undefined' && Object.keys((typeof data.contract !== 'undefined' ? data.contract : {})).length > 0">
                            <div class="card-header" style="background: var(--primary-color); border: 0;">
                                <h5 class="card-title text-white my-2">
                                    <i class="mdi mdi-information"></i> {{data.contract.quarter}} Contract</h5>
                            </div>
                            <div class="card-body p-0 overflow-hidden overlay">
                                <img :src="data.contract.url" class="py-3 text-start mh-100">
                            </div>
                            <div class="card-footer p-2 text-end" v-if="data.contract !== undefined && Object.keys(data).length">
                                <button class="btn btn-primary fw-600" v-if="data.contract.status !== 'FWD'" @click="$emitter.emit('contract_confirm', acceptContract)">Accept Contract</button>
                                <button class="btn fw-600" disabled v-else>Accepted</button>
                            </div>
                        </div>
                        <div class="d-flex flex-column justify-content-center align-items-center bg-white w-100 h-100 mt-2" style="min-height: 300px;" v-else-if="data.contract == undefined">
                            <i class="mdi mdi-newspaper-variant-outline h-auto opacity-3" style="font-size: 100px;"></i>
                            <span class="fw-500 opacity-3">Loading Contract</span>
                        </div>
                        <div class="d-flex flex-column justify-content-center align-items-center bg-white w-100 h-100 mt-2" style="min-height: 300px;" v-else>
                            <i class="mdi mdi-newspaper-variant-outline h-auto opacity-3" style="font-size: 100px;"></i>
                            <span class="fw-500 opacity-3">No Contract found</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column justify-content-center align-items-center bg-white w-100 h-100 opacity-3" v-else-if="data_loading">
                <i class="mdi mdi-chart-box-outline h-auto" style="font-size: 100px;"></i>
                <span class="fw-500">Data is being generated</span>
            </div>
            <div class="d-flex flex-column justify-content-center align-items-center bg-white w-100 h-100 opacity-3" v-else>
                <i class="mdi mdi-close-circle h-auto" style="font-size: 100px;"></i>
                <span class="fw-500">You do not have permission to view this page</span>
            </div>
        </div>
    </div>

    <ConfirmContractModal />
</template>

<script>
import moment from 'moment';
import ConfirmContractModal from './modal/ContractConfirmModal';
export default {
    components: {
        ConfirmContractModal
    },
    data() {
        return {
            filter: {
                // q: moment().quarter(),
                q: moment().month(this.$route.query.m - 1).quarter() ,

                // m: moment().format('M'),
                m: this.$route.query.m,
                // y: moment().format('YYYY')
                y: this.$route.query.y

            },
            needLoad: [
                ['', 'user'],
                // ['header', 'header'],
                // ['table', 'hubspot_matrix'],
                // ['chart', 'ermhubspot_chart'],
                // ['linec', 'erm_morev'],
                // ['linec', 'erm_mogp'],
                // ['tablep', 'erm_prodsupp'],
                ['contract', 'contract']
            ],
            data: {},
            data_loading: true,
            data_type: true,
            show_contract: false,
        }
    },
    methods: {
        async acceptContract() {
            await this.$axios.post('/contract/backroom', this.$qs.stringify({y:this.filter.y,q:this.filter.q,id:this.$route.params.employee_id}))
                    .then((res) => {
                        if(res.status == 200) this.data.contract.status = 'FWD'; 
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
        },
        getmonth() {
            return moment().format('MMMM');
        },
        load() {


        
            this.data_loading = true;
            this.needLoad.forEach(element => {
                this.loadData(element);

            });
        },
        async loadData(type) { 

            await this.$axios.post(`/backroom/${type[1]}/${this.$route.params.employee_id}`, this.$qs.stringify(this.filter))
                    .then((res) => {
                        if(res.data.length || Object.keys(res.data).length) Object.assign(this.data, res.data);  
                        console.log(this.filter);
                        
                        if  ('contract' in this.data){
                            if (this.data.contract.period_type == "Q" ){
                                this.data_type=true;
                            }
                            else{
                                this.data_type=false;
                            }
                        }
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
            this.data_loading = false;
        },
        KFormatter(num) {
            const SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
            const tier = Math.floor(Math.log10(num) / 3) || 0;
            let result = '' + num;
            // if zero, we don't need a suffix
            if (tier > 0) {
                // get suffix and determine scale
                const suffix = SI_SYMBOL[tier];
                const scale = Math.pow(10, tier * 3);
                // scale the number
                const scaled = num / scale;
                // format number and add suffix
                result = scaled.toFixed(1).replace('.0', '') + suffix;
            }
            return result;
        },
        number_format(number) {
            return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
        year(minus = 0) {
            minus -= 1;
            return moment().subtract(minus, "years").format('YYYY');
        },
        format(date = '') {
            return moment(new Date(date)).format('MMMM');
        },
        toggleClose() {
            let main = this.$refs.performance;
            if(main !== undefined) {
                this.show_contract = !main.classList.contains('show');

                if(main.classList.contains('show')) main.classList.remove('show');
                else main.classList.add('show');
            }
        },
        reset() {
            this.data = {};
            this.data_loading = true;
        }
    },
    activated() {

        this.filter.q = moment().month(this.$route.query.m - 1 ).quarter();
        this.filter.m = this.$route.query.m 
        this.filter.y = this.$route.query.y
        if(this.$route.params.employee_id == undefined) this.$router.replace('/error');
        this.load();
 
        
    },
    deactivated() {
        this.show_contract = false;
        this.reset();
    },
    watch: {
        "filter.y": function() {
            this.reset();
            this.load();
        },
        "filter.q": function() {
            this.reset();
            this.load();
        },
        "filter.m": function() {
            this.reset();
            this.load();
        },
        data:{
            handler(val) {
                if(val.name !== undefined) window.document.title = `${val.name} Performance - ${process.env.VUE_APP_APPNAME}`;
            },
            deep: true
        }
    },
    mounted() {
    //  console.log('quarter',moment(moment().set('month', this.$route.p)).quarter())
    }
 
}
</script>

<style scoped>
.chart, .table-responsive {
    min-height: 300px;
}

pre {
     white-space: pre-wrap;       /* css-3 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}

.performance {
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: row;
    height: 100%;
}

.performance.show aside {
    left: 0;
    width: 40vw;
}

.performance aside {
    left: -40vw;
    width: 0;
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    background: #fff;
    position: relative;
    transition: 0.3s ease;
    border-right: 1px solid rgb(245 245 245);
}

.container {
    max-width: 100%;
}

.profile-card {
    width: 100%;
}

.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.bg-primary {
    background-color: var(--sub-color) !important;
}

@media screen and (max-width: 767px) {
    .card-product {
        overflow-x: auto;
        overflow-y: hidden;
    }

    .card-product thead th {
        white-space: nowrap;
    }
}

.list-group-item {
    border-bottom: 1px solid rgb(245 245 245);
}

table.table-stick {
    text-align: left;
    border-collapse: collapse; 
}

table.table-stick th {
    background: white;
    position: sticky;
    top: -1px; /* Don't forget this, required for the stickiness */
    margin-top: -1px;
    box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;
}

.overlay {
    position: relative;
}

.overlay::before {
    content: '';
    background: transparent;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
}

</style>